// removed by extract-text-webpack-plugin
module.exports = {"tile":"tile--tile--iVsJypYR","is-danger":"tile--is-danger--36e8leRo","isDanger":"tile--is-danger--36e8leRo"};


//////////////////
// WEBPACK FOOTER
// ./src/baseComponents/components/Tile/tile.scss
// module id = 609
// module chunks = 0